import * as React from 'react';
import { useSelector } from 'react-redux';

import { CoreSelectProps } from '../types/props';

import { SelectRequestParams } from '@app/store/SelectList/ListActions';
import { getSelectItemState, SelectList } from '@app/store/SelectList/SelectList';
import { SelectRequestProps } from '@app/store/SelectList/SelectsInterfaces';
import { selectListRequest } from '@app/store/SelectList/SelectListRequests';
import { RecordType, StoreType, ItemsType } from '@app/store/SelectList/UtilityTypes';
import { ApplicationState } from '@app/store';

export function useDefault<
	TValue,
	TStore extends keyof SelectList,
	TParams extends SelectRequestParams<TValue>,
>(props: CoreSelectProps<TValue, TStore, TParams>): void {
	const reqProps: SelectRequestProps<TStore> = selectListRequest[props.store];
	const root: StoreType<TStore> = useSelector<ApplicationState, StoreType<TStore>>((state: ApplicationState) =>
		state.selects[props.store]);
	const store: RecordType<TStore> = getSelectItemState<TStore>(root, props.storeKey);

	React.useEffect(() => {
		if (props.shouldPickDefault(store, props.multiple, props.isEmptyValue, reqProps, props.value) && props.pickDefault) {
			const value = props.pickDefault(store.items as ItemsType<TStore>);

			if (value !== undefined) {
				if (props.multiple) {
					props.onChange([value]);
				} else {
					props.onChange(value);
				}
			}
		}
	}, [store.items, store.filters, props.pickDefault, reqProps.isEmpty]);
}
